import React from 'react';
import { NavLink } from 'react-router-dom';
import { Flame, Search, MessageCircle, User, Briefcase, Users, Map } from 'lucide-react';
import { useApp } from '../context/AppContext';
import './BottomNav.css';

export default function BottomNav() {
  const { userType, openAuth, user, notifications } = useApp();
  const isEmployer = userType === 'employer';

  const youthLinks = [
    { to: '/', icon: Flame, label: 'Vorschläge', end: true },
    { to: '/search', icon: Search, label: 'Suchen' },
    { to: '/map', icon: Map, label: 'Karte' },
    { to: '/chat', icon: MessageCircle, label: 'Chat', badge: notifications },
    { to: '/profile', icon: User, label: 'Profil' },
  ];

  const employerLinks = [
    { to: '/', icon: Briefcase, label: 'Inserate', end: true },
    { to: '/talents', icon: Users, label: 'Talente' },
    { to: '/chat', icon: MessageCircle, label: 'Chat', badge: notifications },
    { to: '/profile', icon: User, label: 'Profil' },
  ];

  const links = isEmployer ? employerLinks : youthLinks;

  const handleClick = (e, to) => {
    if (!user && (to === '/chat' || to === '/profile')) {
      e.preventDefault();
      openAuth('login');
    }
  };

  return (
    <nav className="bottom-nav">
      {links.map(({ to, icon: Icon, label, end, badge }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`
          }
          onClick={(e) => handleClick(e, to)}
        >
          <div className="bottom-nav__icon-wrap">
            <Icon size={24} strokeWidth={1.8} />
            {badge > 0 && <span className="bottom-nav__badge">{badge}</span>}
          </div>
          <span className="bottom-nav__label">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
